import $ from 'jquery';

function sentEvent(eventType) {
    dataLayer.push({
        event_name: "contact",
        event_label: eventType,
        event: "fireEvent"
    });
}

$('.js-contact-icon-whatsapp').on('click', function(){
    sentEvent('whatsapp');
});
$('.js-contact-icon-email').on('click', function(){
    sentEvent('email');
});
$('.js-contact-icon-phone').on('click', function(){
    sentEvent('phone');
});
$('.js-header-phone').on('click', function(){
    sentEvent('phone');
});
$('.js-chat-button').on('click', function(){
    sentEvent('chatbot');
});

